"use client";

import React from "react";
import { Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const teamMembers = [{
  name: "Justin Hurst",
  position: "PRESIDENT",
  bio: "Justin Hurst is a committed team player who thrives in collaborative environments. Currently serving as the Government Relations and Advocacy Manager at CSAC and as a Folsom Planning Commissioner, Justin brings extensive experience in public policy and community leadership.",
  image: "https://intimate-sawfly-1.10web.cloud/wp-content/uploads/2026/04/JH-1.jpg?v=hkjnrfw7ynu",
  linkedin: "https://www.linkedin.com/in/justin-hurst-9a1906151/"
}, {
  name: "Adam Hatefi",
  position: "CHIEF STRATEGY OFFICER",
  bio: "Government relations expert specializing in energy policy and regulatory frameworks, with a proven record of shaping legislation, founding advocacy coalitions, and securing major funding initiatives.",
  image: "https://intimate-sawfly-1.10web.cloud/wp-content/uploads/2026/04/image_r1tq5u03.jpg?v=rqei1wigrvt",
  linkedin: "https://www.linkedin.com/in/adamhatefi/"
}, {
  name: "Maclean Ankheyli",
  position: "CHEIF OPERATIONS OFFICER",
  bio: "Formally educated in Operations Research, Maclean drives growth at early stage technology startups through product management and early customer engagement.",
  image: "https://intimate-sawfly-1.10web.cloud/wp-content/uploads/2026/04/image_0imguql8.jpg?v=4id5wbn2t17",
  linkedin: "https://www.linkedin.com/in/macleanankhelyi/"
}];
export default function OurExpertTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="227779" id="team-members" className="py-24 bg-background text-foreground overflow-hidden">
      <div ref={ref} className={cn("container mx-auto px-4 max-w-6xl transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="text-center mb-16">
          <h2 className="font-default text-4xl md:text-5xl font-bold text-foreground mb-4">
            Our Leadership
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto rounded-none opacity-100"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {teamMembers.map((member, i) => <div data-index={i} key={member.name} className="flex justify-center">
              <Card className="group border border-border rounded-sm shadow-none bg-card overflow-hidden w-full max-w-sm transition-all duration-300 hover:-translate-y-2 hover:border-primary">
                <div className="relative overflow-hidden rounded-none aspect-[3/4] mb-6 shadow-none">
                  <img src={member.image} alt={`Portrait of ${member.name}`} className="w-full h-full object-cover grayscale contrast-125 brightness-90 mix-blend-multiply transition-transform duration-700 ease-in-out group-hover:scale-105" />
                  
                  <div className="absolute inset-0 bg-primary/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center p-8 text-center backdrop-blur-none">
                    <p className="text-primary-foreground font-default text-base leading-relaxed mb-8 transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 delay-100">
                      {member.bio}
                    </p>
                    <Link to={member.linkedin} newTab className="text-primary-foreground hover:text-primary-foreground/80 transition-colors transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 duration-500 delay-200" aria-label={`${member.name}'s LinkedIn Profile`}>
                      <Linkedin className="w-8 h-8" strokeWidth={1.5} />
                    </Link>
                  </div>
                </div>

                <div className="text-center p-6">
                  <h3 className="font-serif text-2xl font-semibold text-foreground mb-2">
                    {member.name}
                  </h3>
                  <p className="font-mono text-primary font-medium tracking-widest uppercase text-sm">
                    {member.position}
                  </p>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}